import ResidentBasicInfo from './ResidentBasicInfo';
import ResidentLeaseInfo from './ResidentLeaseInfo';

export default class LeaseResident {
  constructor(data = {}) {
    this.basicInfo = new ResidentBasicInfo(data.basicInfo);
    this.leaseInfo = new ResidentLeaseInfo(data.leaseInfo);
  }
}
